<template>
  <v-card>
    <v-card-text>
      <v-container container--fluid grid-list-md>
         <v-row justify="space-between" align="center">
          <v-col cols="12" sm="12" md="6">
            <v-btn color="blue darken-1" @click="resetRateLimit()">Reset rate limit</v-btn>
          </v-col>
         </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios';
export default {
  name: "ApiSettings",
  props: {
    clientId: Number,
  },
  data() {
    return {
      
    }
  },

  methods: {
    resetRateLimit() {
      axios.get(process.env.API_URL + '/clients/' + this.clientId + '/reset-rate-limits')
        .then((response) => {
            if (response.status === 200) {
                // success message
                alert('Rate limit was successfully reset.');

            } else {
                this.$store.commit('displaySnackbar','ERROR: ' + (response.data !== undefined ? response.data.error : 'An unknown error occurred'));
            }
            
        })
        .catch((response) => {
            this.$store.commit('displaySnackbar','ERROR: ' + (response.data !== undefined ? response.data.error : 'An unknown error occurred'));
        });
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/util/Clients/ApiSettings.vue